import ViewQuizLayout from 'components/ViewQuiz/ViewQuizLayout';

const Tablet = (props) => <ViewQuizLayout device={'tablet'} {...props} />;

export default Tablet;
